/**
 * CARTRIDGES ONLINE — Custom JavaScript
 * V6 Dark Design System enhancements
 *
 * Warehouse theme hooks available:
 * - document.addEventListener('variant:changed', fn)   — variant change on product page
 * - document.addEventListener('product:added', fn)     — product added to cart
 * - document.addEventListener('cart:refresh', fn)      — cart refresh
 */

(function() {
  'use strict';

  /* ============================================================
     FLOATING PARTICLES — Password & store pages
     Subtle animated particles in the background
     ============================================================ */
  function initParticles() {
    // Only on password page for now (lighter pages)
    if (!document.body.classList.contains('template-password')) return;

    const colors = [
      'rgba(232, 25, 122, 0.15)',   // pink
      'rgba(0, 174, 239, 0.12)',    // blue
      'rgba(141, 198, 63, 0.08)',   // green
      'rgba(255, 255, 255, 0.04)'   // white
    ];

    for (var i = 0; i < 18; i++) {
      var particle = document.createElement('div');
      particle.className = 'co-particle';
      var size = Math.random() * 4 + 2;
      var duration = Math.random() * 18 + 12;
      var delay = Math.random() * 15;
      var left = Math.random() * 100;
      var color = colors[Math.floor(Math.random() * colors.length)];

      particle.style.cssText =
        'width:' + size + 'px;' +
        'height:' + size + 'px;' +
        'left:' + left + '%;' +
        'background:' + color + ';' +
        'animation-duration:' + duration + 's;' +
        'animation-delay:' + delay + 's;' +
        'box-shadow: 0 0 ' + (size * 3) + 'px ' + color + ';';

      document.body.appendChild(particle);
    }
  }

  /* ============================================================
     SMOOTH HEADER SCROLL EFFECT
     Header becomes more opaque on scroll
     ============================================================ */
  function initHeaderScroll() {
    var header = document.getElementById('header');
    if (!header) return;

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          var scrollY = window.scrollY || window.pageYOffset;
          if (scrollY > 20) {
            header.style.boxShadow = '0 4px 30px rgba(0,0,0,0.3)';
          } else {
            header.style.boxShadow = 'none';
          }
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* ============================================================
     NEWSLETTER SUCCESS ENHANCEMENT
     Add confetti-like effect when someone subscribes
     ============================================================ */
  function initNewsletterSuccess() {
    var successAlert = document.querySelector('.template-password .alert--success');
    if (!successAlert) return;

    // Pulse the success message
    successAlert.style.animation = 'fadeSlideUp 0.6s ease-out';
    successAlert.style.boxShadow = '0 0 30px rgba(141, 198, 63, 0.15)';
  }

  /* ============================================================
     INIT
     ============================================================ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initParticles();
      initHeaderScroll();
      initNewsletterSuccess();
    });
  } else {
    initParticles();
    initHeaderScroll();
    initNewsletterSuccess();
  }

  // Respect reduced motion
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var particles = document.querySelectorAll('.co-particle');
    for (var j = 0; j < particles.length; j++) {
      particles[j].remove();
    }
  }
})();
